import { render, staticRenderFns } from "./CustomerServiceDialog.vue?vue&type=template&id=56839bfa&scoped=true"
import script from "./CustomerServiceDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerServiceDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CustomerServiceDialog.vue?vue&type=style&index=0&id=56839bfa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_babel-core@7.0.0-bridge.0_@babel+core@7.27._f767d633ff263e3cf51932694db5e4d0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56839bfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/front/game-platform-web/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56839bfa')) {
      api.createRecord('56839bfa', component.options)
    } else {
      api.reload('56839bfa', component.options)
    }
    module.hot.accept("./CustomerServiceDialog.vue?vue&type=template&id=56839bfa&scoped=true", function () {
      api.rerender('56839bfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/site/components/CustomerServiceDialog.vue"
export default component.exports